
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const Index = () => {
  const navigate = useNavigate();
  const { user, profile, loading } = useAuth();
  
  useEffect(() => {
    console.log('Index: User:', user?.id);
    console.log('Index: Profile:', profile);
    console.log('Index: Loading:', loading);
    
    if (!loading) {
      // Only redirect if we have both user AND profile
      if (user && profile) {
        console.log(`Index: Redirecting to ${profile.role} dashboard`);
        // Redirect based on user role
        if (profile.role === 'admin') {
          navigate('/admin/dashboard', { replace: true });
        } else if (profile.role === 'author') {
          navigate('/author/dashboard', { replace: true });
        }
      } else {
        // No user or no profile, redirect to login
        console.log('Index: No user or profile, redirecting to login');
        navigate('/login', { replace: true });
      }
    }
  }, [navigate, user, profile, loading]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">Author Royalty Management</h1>
        {loading ? (
          <div className="flex justify-center mt-4">
            <Loader2 className="h-8 w-8 animate-spin text-royalty-600" />
          </div>
        ) : (
          <p className="text-xl text-gray-600">Redirecting...</p>
        )}
      </div>
    </div>
  );
};

export default Index;
